import _ from 'lodash'

const ExamTypesEnum = {
  Laboratorial: {
    id: 0,
    value: 0,
    label: 'Laboratorial',
    name: 'laboratory'
  },
  MealPLan: {
    id: 1,
    value: 1,
    label: 'Plano Alimentar',
    name: 'mealPlan'
  },
  Others: {
    id: 2,
    value: 1,
    label: 'Outros Exames',
    name: 'others'
  },
}

export default {
  ...ExamTypesEnum,
  ..._.mapKeys(ExamTypesEnum, (value) => value.value),
  list: Object.values(ExamTypesEnum)
}
